export default __webpack_public_path__ + "static/media/paralax0.bdac9953.jpg";